import { LobbyCheckInState } from './lobby-check-in.reducer';
import * as AppState from '../../../state/app.state';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { LobbyWrapUpState } from '../../lobby-wrap-up/state/lobby-wrap-up.reducer';
import { LobbyServiceWithCategory } from '../../shared/models/lobby-service';

export interface State extends AppState.State {
    lobbyCheckIn: LobbyCheckInState;
}

const getLobbyCheckInFeatureState = createFeatureSelector<LobbyCheckInState>('lobbyCheckIn');
const getLobbyWrapUpFeatureState = createFeatureSelector<LobbyWrapUpState>('lobbyWrapUp');

export const getIsLocationChanged = createSelector(
    getLobbyCheckInFeatureState,
    state => state.isLocationChanged
);

export const getShowLobbyCheckInPopup = createSelector(
    getLobbyCheckInFeatureState,
    state => state.showLobbyCheckInPopup
);

export const getlocationId = createSelector(
    getLobbyCheckInFeatureState,
    state => state.locationId
);

export const getLobbyId = createSelector(
    getLobbyCheckInFeatureState,
    state => state.lobbyId
);

export const getTimezoneId = createSelector(
    getLobbyCheckInFeatureState,
    state => state.locationTimezone
);

export const getCurrentLobbyEntryId = createSelector(
    getLobbyCheckInFeatureState,
    state => state.currentLobbyEntryId
);

export const getServiceFilterValue = createSelector(
    getLobbyCheckInFeatureState,
    state => state.serviceFilter
);

export const getWrapUpServiceFilterValue = createSelector(
    getLobbyWrapUpFeatureState,
    state => state.serviceFilter
);

export const getServices = (showCategoriesInLobby: boolean) => createSelector(
    getLobbyCheckInFeatureState,
    getServiceFilterValue,
    (state, filterValue) => {    
        const services = Object.assign([] as LobbyServiceWithCategory[], state.lobbyServices);        
        if (filterValue !== '') {
            if (showCategoriesInLobby) {
                let nonSortedcategories= services.filter(s => s.service.name.toLocaleLowerCase().includes(filterValue.toLocaleLowerCase()))
                            .sort((a, b) => {
                                if (a.categorySortOrder > b.categorySortOrder) {
                                    return 1;
                                } else if (a.categorySortOrder === b.categorySortOrder) {
                                    if (a.service.sortOrder !== null && b.service.sortOrder !== null) {
                                        return (a.service.sortOrder > b.service.sortOrder) ? 1 : -1;
                                    }
                                    return -1;
                                }
                                return -1;
                            });
                            return doSortCategory(nonSortedcategories);
            } else {
                return services.filter(s => s.service.name.toLocaleLowerCase().includes(filterValue.toLocaleLowerCase()))
                                          .sort((a, b) => {
                                            if (a.service.sortOrder !== null && b.service.sortOrder !== null) {
                                                return (a.service.sortOrder > b.service.sortOrder) ? 1 : -1;
                                            }
                                            return -1;
                                          });
            }
        } else {
            if (showCategoriesInLobby) {
                let sortedcategory=services.sort((a, b) => {
                    if (a.categorySortOrder > b.categorySortOrder) {
                        return 1;
                    } else if (a.categorySortOrder === b.categorySortOrder) {
                        if (a.service.sortOrder !== null && b.service.sortOrder !== null) {
                            return (a.service.sortOrder > b.service.sortOrder) ? 1 : -1;
                        }
                        return -1;
                    }
                    return -1;
                });
               return doSortCategory(sortedcategory);
            } else {
                return services.sort((a, b) => {
                    if (a.service.sortOrder !== null && b.service.sortOrder !== null) {
                        return ((a.service.sortOrder > b.service.sortOrder) ? 1 : -1);
                    }
                    return -1;
                });
            }
        }
    }
);

export const getWrapUpServices = (showCategoriesInLobby: boolean) => createSelector(
    getLobbyWrapUpFeatureState,
    getWrapUpServiceFilterValue,
    (state, filterValue) => {    
        const services = Object.assign([] as LobbyServiceWithCategory[], state.lobbyServices);        
        if (filterValue !== '') {
            if (showCategoriesInLobby) {
                let nonSortedcategories= services.filter(s => s.service.name.toLocaleLowerCase().includes(filterValue.toLocaleLowerCase()))
                            .sort((a, b) => {
                                if (a.categorySortOrder > b.categorySortOrder) {
                                    return 1;
                                } else if (a.categorySortOrder === b.categorySortOrder) {
                                    if (a.service.sortOrder !== null && b.service.sortOrder !== null) {
                                        return (a.service.sortOrder > b.service.sortOrder) ? 1 : -1;
                                    }
                                    return -1;
                                }
                                return -1;
                            });
                            return doSortCategory(nonSortedcategories);
            } else {
                return services.filter(s => s.service.name.toLocaleLowerCase().includes(filterValue.toLocaleLowerCase()))
                                          .sort((a, b) => {
                                            if (a.service.sortOrder !== null && b.service.sortOrder !== null) {
                                                return (a.service.sortOrder > b.service.sortOrder) ? 1 : -1;
                                            }
                                            return -1;
                                          });
            }
        } else {
            if (showCategoriesInLobby) {
                let sortedcategory=services.sort((a, b) => {
                    if (a.categorySortOrder > b.categorySortOrder) {
                        return 1;
                    } else if (a.categorySortOrder === b.categorySortOrder) {
                        if (a.service.sortOrder !== null && b.service.sortOrder !== null) {
                            return (a.service.sortOrder > b.service.sortOrder) ? 1 : -1;
                        }
                    } else {
                        return -1;
                    }

                    return -1;
                });
               return doSortCategory(sortedcategory);
            } else {
                return services.sort((a, b) => {
                    if (a.service.sortOrder !== null && b.service.sortOrder !== null) {
                        return (a.service.sortOrder > b.service.sortOrder) ? 1 : -1;
                    }
                    return -1;
                });
            }
        }

        
    }
);

export const doSortCategory=(sortedcategory: LobbyServiceWithCategory[])=> {
    var sortedCategoriesArray = [];
        var unique = sortedcategory.map(x => x.categoryName).filter(onlyUnique);
        for (let i = 0; i < unique.length; i++) {
            var category = <any>{};
            category['catName'] = unique[i];
            category['service'] = sortedcategory.filter(x => x.categoryName == unique[i]).sort();
            sortedCategoriesArray.push(category);
        }
        return sortedCategoriesArray;
   
  }
export const onlyUnique=(value: any, index: number, self: any) => {
    return self.indexOf(value) === index;
  }
  
export const getSpanishSpeakerPreferred = createSelector(
    getLobbyCheckInFeatureState,
    state => state.spanishSpeakerPreferred
);

export const getStaffMembers = createSelector(
    getLobbyCheckInFeatureState,
    getSpanishSpeakerPreferred,
    (state, spanishSpeakerPreferred) => {
        if (spanishSpeakerPreferred) {
            return state.staffMembers.filter(staff => staff.isSpanishSpeaker);
        } else {
            return state.staffMembers;
        }
    }
);

export const getSelectedServices = createSelector(
    getLobbyCheckInFeatureState,
    state => state.selectedLobbyServices
);
export const getShowImpersonate = createSelector(
    getLobbyCheckInFeatureState,
    state => state.showInstantImpersonatePopup
);

export const getSelectedServicesDetails = createSelector(
    getLobbyCheckInFeatureState,
    getSelectedServices,
    (state, selectedServices) => {
        return state.lobbyServices.filter(s => selectedServices.includes(s.service.id));
    }
);

export const getIsInstantAssistSuccess = createSelector(
    getLobbyCheckInFeatureState,
    state => state.instantAssistedLobbyEntryId
);

export const getLobbyCheckIn = createSelector(
    getLobbyCheckInFeatureState,
    getlocationId,
    getLobbyId,
    getTimezoneId,
    getCurrentLobbyEntryId,
    getSelectedServices,
    (state, locationId, lobbyId, timezoneId, currentLobbyEntryId, selectedServices) => {
        if (currentLobbyEntryId === 0 || currentLobbyEntryId === -1) {
            return {
                lobbyEntryId: currentLobbyEntryId,
                LobbyId: lobbyId,
                LocationId: locationId,
                LobbySourceId: 1,
                TimeZoneId: timezoneId,
                AccountNumber: '',
                FirstName: '',
                LastName: '',
                DateOfBirth: '',
                Notes: '',
                PhoneNumber: '',
                EmailAddress: '',
                PreferredLanguage: 1,
                RecieveTextMessage: false,
                AddedBy: 1,
                ServiceRequested: selectedServices,
                CustomFieldValues: {
                    1: ''
                },
                AppointmentId: null,
                UserRequested: null,
                GroupRequested: null
            };
        }

        throw Error('Unexpected code path reached!');
    }
);
